"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jwtDecoder = void 0;
var jwtDecoder = function (jwt) {
    return JSON.parse(Buffer.from(jwt.split('.')[1], 'base64').toString('utf8'));
};
exports.jwtDecoder = jwtDecoder;
//# sourceMappingURL=jwt.js.map